var map = {
	"./Mau-belajar-apa.png": 1500,
	"./buka-lapak.png": 1501,
	"./karier.mu.png": 1502,
	"./pijar.png": 1503,
	"./pintardotco.png": 1504,
	"./pintaria.png": 1505,
	"./tokopedia.png": 1506
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 340;


//////////////////
// WEBPACK FOOTER
// ./src/assets/digital-platform-icon ^\.\/.*$
// module id = 340
// module chunks = 0